import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form"; 
import FormButton from "../FormButton";
import Input from "../Input";
import Select from "../Select";
import { useState, useEffect } from "react";
import { getAllProducts } from "../../http/ProductsHttp"; 
import { sendGoogleOfferHttp } from "../../http/renewalHttp/RenewalHttp"; // Placeholder API import


export default function SendGoogleOfferModal({ offerData, handleClicked, persistedItems, setPersistedItems, ...props }) {
    // 1. State for form fields and dynamic SKU list
    const [selectedSku, setSelectedSku] = useState('');
    const [seats, setSeats] = useState('');
    const [skuDropdownOptions, setSkuDropdownOptions] = useState([]);
    //const [addedSkus, setAddedSkus] = useState([]); // Array to hold multiple SKUs/seats

    function handleClose() {
        handleClicked(false);
    }

    const handleAddSku = () => {    
        // --- Input Validation (Ensure selection and valid seats)
        if (!selectedSku || !seats || parseInt(seats) <= 0) {
            alert("Please select an SKU and enter a valid number of seats.");
            return;
        }

        const newSkuItem = {
            sku_name: selectedSku,
            number_of_seats: parseInt(seats),
        };

        setPersistedItems(prev => [...prev, newSkuItem]);
       
        setSelectedSku('');
        setSeats('');
    };

    const handleRemoveSku = (indexToRemove) => {
        
        setPersistedItems(prev => prev.filter((_, index) => index !== indexToRemove));
    };
    
    // In sendGoogleOfferModal.js

useEffect(() => {
    // 1. DEFINE UPGRADE RULES
    const upgradePaths = {
        'Google Workspace Business Starter': [
            'Google Workspace Business Standard',
            'Google Workspace Enterprise Starter' 
        ],
        'Google Workspace Business Standard': [
            'Google Workspace Business Plus'
        ],
        'Google Workspace Enterprise Starter': [
            'Google Workspace Enterprise Standard'
        ],
        'Google Workspace Enterprise Standard': [
            'Google Workspace Enterprise Plus'
        ],

       
    };


    const currentSkuName = offerData.skuName; 
    
    
    const allowedSkus = upgradePaths[currentSkuName] || [];

    async function fetchSkus() {
        try {
            const response = await getAllProducts(); 
           // alert(offerData.skuName)
            if (response && response.products) {
                let productsToMap = response.products;
                
                
                if (allowedSkus.length > 0) {
                   
                    productsToMap = response.products.filter(product => 
                        allowedSkus.includes(product.productname)
                    );
                } 
                
                const options = productsToMap.map((product) => (
                    <option 
                        key={product.productname}
                        name={product.productname}
                        value={product.productname}>
                        {product.productname}
                    </option>
                ));
                
                setSkuDropdownOptions(options);
            }
        } catch (error) {
            console.error("Failed to fetch or filter SKUs:", error);
        }
    }
    

    if (offerData) {
        fetchSkus();
    }
}, [offerData]);

    // 3. Merged and Final handleSubmit Logic (Uses addedSkus array)
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Final validation: Ensure at least one SKU is in the table
        if (persistedItems.length === 0) { 
             alert("Please add at least one SKU to the offer using the 'Add SKU' button.");
             return;
        }

        let existing_sku = [
            {
                skuName: offerData.skuName,
                seats : offerData.seats
            }
        ]

        
        // 2. Prepare the final request body
        const requestBody = {
            renewal_id: offerData.renewal_id,
            domain_name: offerData.domain_name,
            subscription_id: offerData.subscription_id,
            renewal_date: offerData.renewal_date,
            zoho_contact_id: offerData.zoho_contact_id,
            existing_sku : existing_sku,
                        
            // This array holds all the items from the temporary table
            offered_skus: persistedItems, 
        };
        
        console.log("Final Offer Data to Send:", requestBody);

        // TODO: Uncomment and implement the API call here when ready
         try {
            const response = await sendGoogleOfferHttp(requestBody); 
            if (response) { 
                alert(`Google Offer sent successfully for ${offerData.domain_name}.`);
                // window.location.reload(); // Uncomment if you want to refresh the page on success
            setPersistedItems([]);
            } else {
                alert(`Failed to send Google Offer: ${response.message}`);
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("An error occurred while sending the offer.");
        }
    

        handleClicked(false);
    };

    // JSX structure using createPortal for small, centered modal
    return createPortal(
        <Div className="modal-backdrop">
            <dialog 
                {...props} 
                style={{ 
                    zIndex: 1, 
                    overflow: 'auto', 
                    margin: 'auto',
                }}
            >
                {/* Modal Content Wrapper to control size */}
                <Div className="modal-content" style={{ padding: '20px', width: '450px' }}> 
                    <Div className="form-group">Send Google Offer</Div>
                    
                    <Form onSubmit={handleSubmit}>
                        
                        {/* ----------------- SKU and Seats INPUTS ----------------- */}
                        {/* SKU Dropdown Field */}
                        <Div className="form-group row">
                            <label htmlFor="skuName" className="col-md-4 col-form-label">SKU Name:</label>
                            <Div className="col-md-8">
                                <Select
                                    name='skuName'
                                    options={skuDropdownOptions} // Dynamic options list
                                    defaultValue={selectedSku}
                                    onChange={(e) => setSelectedSku(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </Div>
                        </Div>

                        {/* Seats Input Field */}
                        <Div className="form-group row mb-2"> 
                            <label htmlFor="seats" className="col-md-4 col-form-label">Seats:</label>
                            <Div className="col-md-8">
                                <Input
                                    type='number'
                                    name='seats'
                                    id='seats'
                                    value={seats}
                                    onChange={(e) => setSeats(e.target.value)}
                                
                                />
                            </Div>
                        </Div>
                        
                        {/* ----------------- ADD BUTTON ----------------- */}
                        <Div className="d-flex justify-content-end mb-4">
                            <FormButton 
                                type='button' 
                                className="btn btn-secondary submit-btn" 
                                onClick={handleAddSku}
                            >
                                Add SKU
                            </FormButton>
                        </Div>

                        {/* ----------------- SKU LIST TABLE (Displays added items) ----------------- */}
                        {persistedItems.length > 0 && (
                            <Div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
                                <table className="table table-striped table-sm" style={{ width: '100%', marginBottom: '0' }}>
                                    <thead>
                                        <tr>
                                            <th>SKU Name</th>
                                            <th style={{ width: '15%' }}>Seats</th>
                                            <th style={{ width: '10%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {persistedItems.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.sku_name}</td>
                                                <td>{item.number_of_seats}</td>
                                                <td>
                                                    <FormButton 
                                                        type='button' 
                                                        className="btn btn-danger btn-sm" 
                                                        onClick={() => handleRemoveSku(index)}
                                                        style={{ padding: '2px 5px', fontSize: '10px' }}
                                                    >
                                                        X
                                                    </FormButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Div>
                        )}

                        {/* ----------------- SUBMIT BUTTONS ----------------- */}
                        <Div className="d-flex justify-content-end mt-4">
                            <FormButton type='submit' className="btn btn-primary submit-btn">Send Offer</FormButton>
                            <FormButton type='button' className="btn btn-primary submit-btn ml-2" onClick={handleClose}>Close</FormButton>
                        </Div>
                    </Form>
                </Div>
            </dialog>
        </Div>,
        document.getElementById("modal") 
    );
}